export default __webpack_public_path__ + "static/media/Shadowed Valleys-10.f93986ce.jpg";